<div class="signup-page-content">
  <h3 class="primary-color no-margin"><b>MON ESPACE</b></h3>
  <div>
    <h2>Créer mon compte</h2>
  </div>

  <ng-container *ngIf="successInscription; else displayContent">
    <ags-success-inscription [email]="dataToSuccess"></ags-success-inscription>
  </ng-container>

  <ng-template #displayContent>
    <div class="flex">
      <span class="small-padding"><b>Je suis :</b></span>
      <kendo-dropdownlist [data]="listClient" [(value)]="client" (selectionChange)="clientSelected($event)">
      </kendo-dropdownlist>
    </div>

    <form [formGroup]="formSignup" (ngSubmit)="signUpCheck()" class="form-content">
      <div class="flex">
        <div class="entreprise flex-row" *ngIf="client === 'une entreprise / organisation'">
          <h3><b>Mon organisation</b></h3>

          <kendo-combobox [data]="listEntreprise" [textField]="'libelle'" [valueField]="'libelle'"
                          [placeholder]="'Type d\'entreprise*'" formControlName="typeEntreprise" class="full-size" [disabled]="isRequesting">
          </kendo-combobox>
          <div class="full-size"
               *ngIf="formSignup.get('typeEntreprise').hasError('required') && formSignup.get('typeEntreprise').touched">
            Veuillez renseigner le type d'entreprise
          </div>

          <input kendoTextBox [placeholder]="'Raison sociale*'" formControlName="raisonSociale" class="full-size" [disabled]="isRequesting" />
          <div class="full-size"
               *ngIf="formSignup.get('raisonSociale').hasError('required') && formSignup.get('raisonSociale').touched">
            Veuillez renseigner une raison sociale
          </div>

          <input kendoTextBox [placeholder]="'Adresse*'" formControlName="adresse" class="full-size" [disabled]="isRequesting" />
          <div class="full-size"
               *ngIf="formSignup.get('adresse').hasError('required') && formSignup.get('adresse').touched">
            Veuillez renseigner une adresse
          </div>

          <div class="flex full-size">
            <input kendoTextBox [placeholder]="'Code postal'" formControlName="code" class="small-r-margin" [disabled]="isRequesting" />
            <input kendoTextBox [placeholder]="'Ville*'" formControlName="ville" class="small-l-margin" [disabled]="isRequesting" />
          </div>
          <div class="full-size" *ngIf="formSignup.get('ville').hasError('required') && formSignup.get('ville').touched">
            Veuillez renseigner une ville
          </div>
        </div>

        <div class="particulier entreprise flex-row">
          <h3><b>informations</b></h3>

          <input kendoTextBox [placeholder]="'Email*'" formControlName="email" class="full-size" [disabled]="isRequesting" />
          <div class="full-size" *ngIf="formSignup.get('email').hasError('required') && formSignup.get('email').touched">
            Veuillez renseigner une adresse mail
          </div>
          <div class="full-size" *ngIf="formSignup.get('email').hasError('email') && formSignup.get('email').touched">
            Veuillez renseigner une adresse mail valide
          </div>

          <input kendoTextBox [placeholder]="'Confirmation Email*'" formControlName="confirmEmail"
           class="full-size" [disabled]="isRequesting" />
          <div class="full-size"
               *ngIf="formSignup.get('confirmEmail').hasError('required') && formSignup.get('confirmEmail').touched">
            Veuillez confirmer votre adresse mail
          </div>
          <div class="full-size"
               *ngIf="formSignup.get('confirmEmail').hasError('notMatch') && formSignup.get('confirmEmail').touched">
            Cette adresse ne correspond à l'email renseigné
          </div>

          <div class="flex full-size">
            <kendo-combobox [data]="listCiv" [placeholder]="'Civ.'" formControlName="civ" class="small-r-margin">
            </kendo-combobox>
            <input kendoTextBox [placeholder]="'Nom*'" formControlName="nom" class="small-r-margin small-l-margin" [disabled]="isRequesting" />
            <input kendoTextBox [placeholder]="'Prénom*'" formControlName="prenom" class="small-l-margin" [disabled]="isRequesting" />
          </div>

          <div class="full-size" *ngIf="formSignup.get('nom').hasError('required') && formSignup.get('nom').touched">
            Veuillez renseigner un nom
          </div>
          <div class="full-size"
               *ngIf="formSignup.get('prenom').hasError('required') && formSignup.get('prenom').touched">
            Veuillez renseigner un prénom
          </div>
          <p class="full-size small-margin">{{ getParamByCode('HTML_CREATION_CLIENT').value }}</p>
        </div>
      </div>
      <div style="text-align: right; margin-right: 1em;">
        <button kendoButton class="colored-text" [primary]="true" [disabled]="formSignup.invalid || isRequesting">
          <ng-container *ngIf="isRequesting; else defautText">
            <div uk-spinner></div> Chargement...
          </ng-container>
          <ng-template #defautText>
            Créer mon compte
          </ng-template>
        </button>
      </div>
      <div class="more-info-form primary-border" [hidden]="!signupError">
        <div class="full-size small-margin" [innerHtml]="signupError"></div>
        <div class="full-size" *ngIf="homonymeE === true">
          <div class="two-block">
            <input kendoTextBox [placeholder]="'Numéro de TVA intracommunautaire*'" formControlName="tva"
                   class="full-size" [disabled]="isRequesting" />
            <div [hidden]="!(formSignup.get('tva').hasError('required') && formSignup.get('tva').touched)">
              Veuillez renseigner un numéro de TVA
            </div>
          </div>

          <div class="two-block">
            <input kendoTextBox [placeholder]="'SIRET*'" formControlName="siret" class="full-size" [disabled]="isRequesting" />
            <div [hidden]="!(formSignup.get('siret').hasError('required') && formSignup.get('siret').touched)">
              Veuillez renseigner un numéro de SIRET
            </div>
          </div>
        </div>
        <div class="full-size" *ngIf="homonymeP === true">
          <div class="one-block">
            <input kendoTextBox [placeholder]="'Adresse*'" formControlName="adresseP" class="full-size" [disabled]="isRequesting" />
            <div *ngIf="formSignup.get('adresseP').hasError('required') && formSignup.get('adresseP').touched">
              Veuillez renseigner une adresse
            </div>
          </div>

          <div class="full-size">
            <div class="two-block">
              <input kendoTextBox [placeholder]="'ECode postal*'" formControlName="codeP" class="full-size" [disabled]="isRequesting" />
              <div *ngIf="formSignup.get('codeP').hasError('required') && formSignup.get('codeP').touched">
                Veuillez renseigner un code postal
              </div>
            </div>
            <div class="two-block">
              <input kendoTextBox [placeholder]="'Ville*'" formControlName="villeP" class="full-size" [disabled]="isRequesting" />
              <div *ngIf="formSignup.get('villeP').hasError('required') && formSignup.get('villeP').touched">
                Veuillez renseigner une ville
              </div>
            </div>
          </div>

          <div class="one-block">
            <kendo-dateinput format="dd/MM/yyyy" [formatPlaceholder]="{ year: 'AAAA', month: 'MM', day: 'JJ' }"
                             [placeholder]="'Date de naissance*'" formControlName="date" class="full-size" [disabled]="isRequesting" >
            </kendo-dateinput>
            <div *ngIf="formSignup.get('date').hasError('required') && formSignup.get('date').touched">
              Veuillez renseigner votre date de naissance
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-template>
</div>
